import { render } from "./SDGCarousel.vue?vue&type=template&id=92da27ca"
import script from "./SDGCarousel.vue?vue&type=script&lang=js"
export * from "./SDGCarousel.vue?vue&type=script&lang=js"

import "./SDGCarousel.vue?vue&type=style&index=0&id=92da27ca&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__